/** Acceptance remains available during a resumable acceptance attempt. */
export function quoteIsAcceptable(status: string, validUntil: string, now = Date.now()): boolean {
  return (status === "open" || status === "accepting") && new Date(validUntil).getTime() > now;
}

export function quoteStatusTone(status: string): "ok" | "pending" | "error" | "neutral" | "revoked" {
  if (status === "accepted") return "ok";
  if (status === "open" || status === "accepting") return "pending";
  if (status === "expired") return "error";
  if (status === "cancelled") return "revoked";
  return "neutral";
}
